var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.828 18.8281C38.1808 18.8281 37.6561 19.3528 37.6561 20C37.6561 29.7356 29.7355 37.6561 20 37.6561C10.2643 37.6561 2.34381 29.7356 2.34381 20C2.34381 10.2643 10.2643 2.34381 20 2.34381C22.9686 2.34381 25.8563 3.08091 28.4342 4.48544L26.9691 5.95051C26.634 6.28566 26.5338 6.78964 26.7151 7.22761C26.8965 7.6655 27.3237 7.95104 27.7977 7.95104H33.405C34.0521 7.95104 34.5768 7.42636 34.5768 6.77917V1.17194C34.5768 0.69796 34.2914 0.270697 33.8534 0.0892915C33.4154 -0.0921918 32.9114 0.00812015 32.5763 0.343353L30.1531 2.76654C27.0837 0.954286 23.5938 0.000151434 19.9999 0.000151434C14.6577 0.000151434 9.63526 2.08053 5.85778 5.85793C2.0803 9.63549 0 14.6579 0 20C0 25.3422 2.0803 30.3646 5.85778 34.1421C9.63533 37.9196 14.6577 40 19.9999 40C25.342 40 30.3644 37.9196 34.1419 34.1421C37.9195 30.3646 39.9997 25.3422 39.9997 20C39.9998 19.3528 39.4752 18.8281 38.828 18.8281Z",
    fill: "#99D7D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5311 18.8281H21.1719V12.4688C21.1719 11.8216 20.6472 11.2969 20 11.2969C19.3528 11.2969 18.8281 11.8216 18.8281 12.4688V20C18.8281 20.6472 19.3528 21.1719 20 21.1719H27.5311C28.1783 21.1719 28.703 20.6472 28.703 20C28.703 19.3528 28.1783 18.8281 27.5311 18.8281Z",
    fill: "#99D7D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.09009307e24180e8f1e64f786de1539c.svg";
export { ForwardRef as ReactComponent };